var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "promoter-container" },
    [
      _c(
        "div",
        { staticClass: "stat-cards" },
        [
          _c("el-card", { staticClass: "stat-card" }, [
            _c("div", { staticClass: "stat-content" }, [
              _c("div", { staticClass: "stat-number" }, [
                _vm._v(_vm._s(_vm.totalCount)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-label" }, [_vm._v("推广商总数")]),
            ]),
          ]),
          _vm._v(" "),
          _c("el-card", { staticClass: "stat-card" }, [
            _c("div", { staticClass: "stat-content" }, [
              _c("div", { staticClass: "stat-number" }, [
                _vm._v(_vm._s(_vm.activeCount || 0)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-label" }, [_vm._v("活跃推广商")]),
            ]),
          ]),
          _vm._v(" "),
          _c("el-card", { staticClass: "stat-card" }, [
            _c("div", { staticClass: "stat-content" }, [
              _c("div", { staticClass: "stat-number" }, [
                _vm._v(_vm._s(_vm.newCount || 0)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-label" }, [_vm._v("新增推广商")]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "search-card" },
        [
          _c(
            "el-form",
            {
              staticClass: "search-form",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "公司名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入公司名称" },
                    model: {
                      value: _vm.searchForm.companyName,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "companyName", $$v)
                      },
                      expression: "searchForm.companyName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "链接状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择状态" },
                      model: {
                        value: _vm.searchForm.linkStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "linkStatus", $$v)
                        },
                        expression: "searchForm.linkStatus",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "全部", value: null },
                      }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "启用", value: 1 } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "禁用", value: 0 } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "区域" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.searchForm.isOverseas,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "isOverseas", $$v)
                        },
                        expression: "searchForm.isOverseas",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "全部", value: null },
                      }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "海外", value: 1 } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "国内", value: 0 } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleQuery },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.handleReset } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "list-card" },
        [
          _c(
            "div",
            { staticClass: "table-top" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", plain: "" },
                  on: { click: _vm.handleAddPromoter },
                },
                [_vm._v("新增推广商")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: { type: "primary", plain: "" },
                  on: { click: _vm.handleExport },
                },
                [_vm._v("导出数据")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.promoterList, size: "small" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              (_vm.currentPage - 1) * _vm.pageSize +
                                scope.$index +
                                1
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "promoterCode", label: "推广商编码" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "companyName", label: "公司名称" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "region", label: "区域", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                scope.row.isOverseas === 1 ? "success" : "info",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  scope.row.isOverseas === 1 ? "海外" : "国内"
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "contactName", label: "联系人" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "会员注册佣金(%)",
                  prop: "memberRegCommission",
                  width: "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "订单佣金比例(%)",
                  prop: "orderCommission",
                  width: "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "linkStatus", label: "链接状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-color": "#13ce66",
                            "inactive-color": "#ff4949",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleLinkStatusChange(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.linkStatus,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "linkStatus", $$v)
                            },
                            expression: "scope.row.linkStatus",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "createTime", label: "创建时间", width: "180" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", fixed: "right", width: "300" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.copyLink(scope.row)
                              },
                            },
                          },
                          [_vm._v("复制推广链接")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.totalCount,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pageSize,
            },
            on: {
              "current-change": _vm.handleCurrentChange,
              "size-change": _vm.handleSizeChange,
            },
            model: {
              value: _vm.currentPage,
              callback: function ($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.isEditMode ? "编辑推广商" : "新增推广商",
            visible: _vm.dialogVisible,
            width: "60%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.isEditMode ? "编辑推广商" : "新增推广商")),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { float: "right", "margin-right": "50px" } },
              [
                _vm.isEditMode
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "mini",
                          loading: _vm.sendLinkLoading,
                        },
                        on: { click: _vm.handleSendLink },
                      },
                      [_vm._v("发送链接")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "promoterForm",
              attrs: {
                model: _vm.promoterForm,
                rules: _vm.rules,
                "label-width": "140px",
              },
            },
            [
              _c("div", { staticClass: "form-section" }, [
                _c("h3", [_vm._v("基本信息")]),
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "公司名称", prop: "companyName" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入公司名称" },
                            model: {
                              value: _vm.promoterForm.companyName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.promoterForm,
                                  "companyName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "promoterForm.companyName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "公司网址", prop: "companyUrl" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入公司网址" },
                            model: {
                              value: _vm.promoterForm.companyUrl,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.promoterForm,
                                  "companyUrl",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "promoterForm.companyUrl",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "联系人姓名", prop: "contactName" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "联系人姓名" },
                            model: {
                              value: _vm.promoterForm.contactName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.promoterForm,
                                  "contactName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "promoterForm.contactName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "联系电话", prop: "contactPhone" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "联系电话" },
                            model: {
                              value: _vm.promoterForm.contactPhone,
                              callback: function ($$v) {
                                _vm.$set(_vm.promoterForm, "contactPhone", $$v)
                              },
                              expression: "promoterForm.contactPhone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "联系邮箱", prop: "contactEmail" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "邮箱地址" },
                            model: {
                              value: _vm.promoterForm.contactEmail,
                              callback: function ($$v) {
                                _vm.$set(_vm.promoterForm, "contactEmail", $$v)
                              },
                              expression: "promoterForm.contactEmail",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "推广商编码", prop: "promoterCode" },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "系统自动生成",
                              disabled: "",
                            },
                            model: {
                              value: _vm.promoterForm.promoterCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.promoterForm, "promoterCode", $$v)
                              },
                              expression: "promoterForm.promoterCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否海外推广商",
                            prop: "isOverseas",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              on: { change: _vm.handleIsOverseasChange },
                              model: {
                                value: _vm.promoterForm.isOverseas,
                                callback: function ($$v) {
                                  _vm.$set(_vm.promoterForm, "isOverseas", $$v)
                                },
                                expression: "promoterForm.isOverseas",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "否", value: 0 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "是", value: 1 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "国家", prop: "country" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "国家" },
                            model: {
                              value: _vm.promoterForm.country,
                              callback: function ($$v) {
                                _vm.$set(_vm.promoterForm, "country", $$v)
                              },
                              expression: "promoterForm.country",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-section" }, [
                _c("h3", [_vm._v("推广设置")]),
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "落地页url", prop: "landingPage" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "落地页url" },
                            model: {
                              value: _vm.promoterForm.landingPage,
                              callback: function ($$v) {
                                _vm.$set(_vm.promoterForm, "landingPage", $$v)
                              },
                              expression: "promoterForm.landingPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "推广页链接", prop: "promoterLink" },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.promoterForm.promoterCode
                                ? _vm.promoterForm.landingPage +
                                  "?source=" +
                                  _vm.promoterForm.promoterCode
                                : "",
                              placeholder: "推广页链接",
                              disabled: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "会员注册佣金(%)",
                            prop: "memberRegCommission",
                          },
                        },
                        [
                          _c("el-input-number", {
                            attrs: { min: 0 },
                            model: {
                              value: _vm.promoterForm.memberRegCommission,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.promoterForm,
                                  "memberRegCommission",
                                  $$v
                                )
                              },
                              expression: "promoterForm.memberRegCommission",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "订单佣金比例(%)",
                            prop: "orderCommission",
                          },
                        },
                        [
                          _c("el-input-number", {
                            attrs: { min: 0 },
                            model: {
                              value: _vm.promoterForm.orderCommission,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.promoterForm,
                                  "orderCommission",
                                  $$v
                                )
                              },
                              expression: "promoterForm.orderCommission",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "启用推广链接", prop: "linkStatus" },
                        },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-value": 1,
                              "inactive-value": 0,
                              "active-color": "#13ce66",
                              "inactive-color": "#ff4949",
                            },
                            model: {
                              value: _vm.promoterForm.linkStatus,
                              callback: function ($$v) {
                                _vm.$set(_vm.promoterForm, "linkStatus", $$v)
                              },
                              expression: "promoterForm.linkStatus",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-section" }, [
                _c("h3", [_vm._v("结算信息")]),
              ]),
              _vm._v(" "),
              _vm.promoterForm.isOverseas == 0
                ? _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "开户名",
                                prop: "settleBankName",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "银行名称" },
                                model: {
                                  value: _vm.promoterForm.settleBankName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.promoterForm,
                                      "settleBankName",
                                      $$v
                                    )
                                  },
                                  expression: "promoterForm.settleBankName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "开户银行", prop: "bankName" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "银行账号" },
                                model: {
                                  value: _vm.promoterForm.bankName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.promoterForm, "bankName", $$v)
                                  },
                                  expression: "promoterForm.bankName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "银行账号",
                                prop: "settleBankAccount",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "银行账号" },
                                model: {
                                  value: _vm.promoterForm.settleBankAccount,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.promoterForm,
                                      "settleBankAccount",
                                      $$v
                                    )
                                  },
                                  expression: "promoterForm.settleBankAccount",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "持卡人姓名",
                                prop: "cardholderName",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "持卡人姓名" },
                                model: {
                                  value: _vm.promoterForm.cardholderName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.promoterForm,
                                      "cardholderName",
                                      $$v
                                    )
                                  },
                                  expression: "promoterForm.cardholderName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.promoterForm.isOverseas == 1
                ? _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "开户名全称",
                                prop: "settleBankName",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "银行名称" },
                                model: {
                                  value: _vm.promoterForm.settleBankName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.promoterForm,
                                      "settleBankName",
                                      $$v
                                    )
                                  },
                                  expression: "promoterForm.settleBankName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "开户银行", prop: "bankName" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "银行名称" },
                                model: {
                                  value: _vm.promoterForm.bankName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.promoterForm, "bankName", $$v)
                                  },
                                  expression: "promoterForm.bankName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "收款方银行账号",
                                prop: "settleBankAccount",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "收款方银行账号" },
                                model: {
                                  value: _vm.promoterForm.settleBankAccount,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.promoterForm,
                                      "settleBankAccount",
                                      $$v
                                    )
                                  },
                                  expression: "promoterForm.settleBankAccount",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "收款人所在省",
                                prop: "province",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "收款人所在省" },
                                model: {
                                  value: _vm.promoterForm.province,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.promoterForm, "province", $$v)
                                  },
                                  expression: "promoterForm.province",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "收款人所在市", prop: "city" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "收款人所在市" },
                                model: {
                                  value: _vm.promoterForm.city,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.promoterForm, "city", $$v)
                                  },
                                  expression: "promoterForm.city",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "收款人邮政编码",
                                prop: "postalCode",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "收款人邮政编码" },
                                model: {
                                  value: _vm.promoterForm.postalCode,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.promoterForm,
                                      "postalCode",
                                      $$v
                                    )
                                  },
                                  expression: "promoterForm.postalCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "收款人银行地址",
                                prop: "bankAddress",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "收款人银行地址" },
                                model: {
                                  value: _vm.promoterForm.bankAddress,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.promoterForm,
                                      "bankAddress",
                                      $$v
                                    )
                                  },
                                  expression: "promoterForm.bankAddress",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "SWIFT/BIC", prop: "swiftOrBic" },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "SWIFT/BIC码" },
                                model: {
                                  value: _vm.promoterForm.swiftOrBic,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.promoterForm,
                                      "swiftOrBic",
                                      $$v
                                    )
                                  },
                                  expression: "promoterForm.swiftOrBic",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isEditMode
                ? [
                    _c("div", { staticClass: "form-section" }, [
                      _c("h3", [_vm._v("最近活动")]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "链接点击数",
                                  prop: "bankAddress",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.promoterForm.linkClickCount,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.promoterForm,
                                        "linkClickCount",
                                        $$v
                                      )
                                    },
                                    expression: "promoterForm.linkClickCount",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "会员注册数",
                                  prop: "bankAddress",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.promoterForm.memberRegCount,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.promoterForm,
                                        "memberRegCount",
                                        $$v
                                      )
                                    },
                                    expression: "promoterForm.memberRegCount",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "带来订单数",
                                  prop: "bankAddress",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.promoterForm.orderCount,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.promoterForm,
                                        "orderCount",
                                        $$v
                                      )
                                    },
                                    expression: "promoterForm.orderCount",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "会员注册转化率",
                                  prop: "bankAddress",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { disabled: "" },
                                  model: {
                                    value:
                                      _vm.promoterForm.memberRegConversionRate,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.promoterForm,
                                        "memberRegConversionRate",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "promoterForm.memberRegConversionRate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-section" }, [
                      _c("h3", [_vm._v("图表")]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "chart-header" },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "year-selector",
                            attrs: { inline: true },
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "年份" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "请选择年份" },
                                    on: { change: _vm.handleYearChange },
                                    model: {
                                      value: _vm.year,
                                      callback: function ($$v) {
                                        _vm.year = $$v
                                      },
                                      expression: "year",
                                    },
                                  },
                                  _vm._l(_vm.years, function (y) {
                                    return _c("el-option", {
                                      key: y,
                                      attrs: { label: y, value: y },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "chart-container" }, [
                      _c("div", {
                        staticStyle: { width: "100%", height: "400px" },
                        attrs: { id: "conversionChart" },
                      }),
                    ]),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleSavePromoter },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }